import { httpRequest } from "../../http";
import type { Ad } from "@models/Ad.model";

export interface StoreCollectionPage {
    collection_id: number;
    collection_name: string;
    hero: string | null;
    copy_text: string | null;
    ads: Ad[];
    children: StoreCollectionPage[];
    /** ad_id -> tag ids, flat for the whole page and set on the root only (MPN-1575). */
    ad_tags?: Record<number, number[]>;
}

export class CommandGetStoreCollection {
    async run(
        organizationId: string,
        collectionId: string,
        name: string,
    ): Promise<StoreCollectionPage | undefined> {
        const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/store/collections/${collectionId}/`;
        const url = `${base}?${new URLSearchParams({ name })}`;
        try {
            return await httpRequest<StoreCollectionPage>(url);
        } catch (error) {
            console.error("Error fetching store collection:", error);
            throw error;
        }
    }
}
